import React, { Suspense } from 'react';

const FpMainComponent = React.lazy(
    () => import('../Components/FullPage/FpMain/fp.main.component')
);

/*
    Full Page Component is for desktop and full page webview.
    The main component is wrapped in Auth Component, App and CurrentUserContext
*/
export default function FullPage() {
    return (
        <div className="cv-fullpage-entry-point">
            <Suspense fallback={null}>
                <FpMainComponent />
            </Suspense>
        </div>
    );
}
